/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_Add_Member_Or_EmailInputs */

const th_org_add_member_or_email = /** @type {(inputs: Org_Add_Member_Or_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หรือเชิญด้วยอีเมล`)
};

const en_org_add_member_or_email = /** @type {(inputs: Org_Add_Member_Or_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Or invite by email`)
};

const ja_org_add_member_or_email = /** @type {(inputs: Org_Add_Member_Or_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`またはメールで招待`)
};

const zh_org_add_member_or_email = /** @type {(inputs: Org_Add_Member_Or_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`或通过邮件邀请`)
};

const es_org_add_member_or_email = /** @type {(inputs: Org_Add_Member_Or_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O invitar por correo`)
};

const pt_org_add_member_or_email = /** @type {(inputs: Org_Add_Member_Or_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ou convidar por e-mail`)
};

const id_org_add_member_or_email = /** @type {(inputs: Org_Add_Member_Or_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atau undang lewat email`)
};

const fr_org_add_member_or_email = /** @type {(inputs: Org_Add_Member_Or_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ou inviter par e-mail`)
};

const tl_org_add_member_or_email = /** @type {(inputs: Org_Add_Member_Or_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O mag-anyaya sa email`)
};

const vi_org_add_member_or_email = /** @type {(inputs: Org_Add_Member_Or_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoặc mời qua email`)
};

const ko_org_add_member_or_email = /** @type {(inputs: Org_Add_Member_Or_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`또는 이메일로 초대`)
};

const de_org_add_member_or_email = /** @type {(inputs: Org_Add_Member_Or_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oder per E-Mail einladen`)
};

const ru_org_add_member_or_email = /** @type {(inputs: Org_Add_Member_Or_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Или пригласить по почте`)
};

const tr_org_add_member_or_email = /** @type {(inputs: Org_Add_Member_Or_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya da e-postayla davet edin`)
};

const it_org_add_member_or_email = /** @type {(inputs: Org_Add_Member_Or_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oppure invita via email`)
};

const pl_org_add_member_or_email = /** @type {(inputs: Org_Add_Member_Or_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Albo zaproś e-mailem`)
};

const uk_org_add_member_or_email = /** @type {(inputs: Org_Add_Member_Or_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Або запросити поштою`)
};

const hi_org_add_member_or_email = /** @type {(inputs: Org_Add_Member_Or_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`या ईमेल से आमंत्रित करें`)
};

const ar_org_add_member_or_email = /** @type {(inputs: Org_Add_Member_Or_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أو ادعُ بالبريد`)
};

const ms_org_add_member_or_email = /** @type {(inputs: Org_Add_Member_Or_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atau jemput melalui e-mel`)
};

const bn_org_add_member_or_email = /** @type {(inputs: Org_Add_Member_Or_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অথবা ইমেলে আমন্ত্রণ করুন`)
};

const zh_tw2_org_add_member_or_email = /** @type {(inputs: Org_Add_Member_Or_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`或以電子郵件邀請`)
};

const zh_hk2_org_add_member_or_email = /** @type {(inputs: Org_Add_Member_Or_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`或以電子郵件邀請`)
};

const ur_org_add_member_or_email = /** @type {(inputs: Org_Add_Member_Or_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`یا ای میل سے مدعو کریں`)
};

const fa_org_add_member_or_email = /** @type {(inputs: Org_Add_Member_Or_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`یا با ایمیل دعوت کنید`)
};

const sw_org_add_member_or_email = /** @type {(inputs: Org_Add_Member_Or_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Au alika kwa barua pepe`)
};

const nl_org_add_member_or_email = /** @type {(inputs: Org_Add_Member_Or_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Of nodig uit per e-mail`)
};

/**
* | output |
* | --- |
* | "Or invite by email" |
*
* @param {Org_Add_Member_Or_EmailInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const org_add_member_or_email = /** @type {((inputs?: Org_Add_Member_Or_EmailInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Add_Member_Or_EmailInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_org_add_member_or_email(inputs)
	if (locale === "ja") return ja_org_add_member_or_email(inputs)
	if (locale === "zh") return zh_org_add_member_or_email(inputs)
	if (locale === "es") return es_org_add_member_or_email(inputs)
	if (locale === "pt") return pt_org_add_member_or_email(inputs)
	if (locale === "id") return id_org_add_member_or_email(inputs)
	if (locale === "fr") return fr_org_add_member_or_email(inputs)
	if (locale === "tl") return tl_org_add_member_or_email(inputs)
	if (locale === "vi") return vi_org_add_member_or_email(inputs)
	if (locale === "ko") return ko_org_add_member_or_email(inputs)
	if (locale === "de") return de_org_add_member_or_email(inputs)
	if (locale === "ru") return ru_org_add_member_or_email(inputs)
	if (locale === "tr") return tr_org_add_member_or_email(inputs)
	if (locale === "it") return it_org_add_member_or_email(inputs)
	if (locale === "pl") return pl_org_add_member_or_email(inputs)
	if (locale === "uk") return uk_org_add_member_or_email(inputs)
	if (locale === "hi") return hi_org_add_member_or_email(inputs)
	if (locale === "ar") return ar_org_add_member_or_email(inputs)
	if (locale === "ms") return ms_org_add_member_or_email(inputs)
	if (locale === "bn") return bn_org_add_member_or_email(inputs)
	if (locale === "zh-TW") return zh_tw2_org_add_member_or_email(inputs)
	if (locale === "zh-HK") return zh_hk2_org_add_member_or_email(inputs)
	if (locale === "ur") return ur_org_add_member_or_email(inputs)
	if (locale === "fa") return fa_org_add_member_or_email(inputs)
	if (locale === "sw") return sw_org_add_member_or_email(inputs)
	if (locale === "nl") return nl_org_add_member_or_email(inputs)
	return en_org_add_member_or_email(inputs)
});